export const environment = {
    webappsRootURL: 'https://project1apps.epa.ohio.gov',
    ebizRootURL: 'https://epaproject1apps.epa.ohio.gov',
    clientID : '7b2e8419-7a21-4b0d-aa87-61c1208bf364', 
    redirectURI: 'https://stars.project1.epa.ohio.gov/', 
    webappsHomeURL: 'https://project1apps.epa.ohio.gov'
};
